import React from "react";
import { useSelector } from "react-redux";

import {
  FormControl,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import classnames from "classnames";

import { MenuItemLink } from "react-admin";

import { useUser } from "../../authenticatorApp/UserContext";
import {
  InboundIcon,
  LogoutIcon,
  OutboundIcon,
  ProfileIcon,
  SearchIcon,
  UserIcon,
} from "../../components/common/iconography";
import { DASHBOARD_PATH, DELIVERIES_PATH, PICKUPS_PATH } from "../carrierPaths";
import { AclType } from "../../utils/constants";
import { truncateText } from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
  },
  open: {
    width: 210,
  },
  closed: {
    width: 55,
  },
  formControlOpen: {
    marginLeft: theme.spacing(2),
    height: theme.spacing(4),
    minWidth: 192,
  },
  formControlClosed: {
    display: "none",
  },
}));

export const CarrierMenu = ({ onMenuClick, dense }) => {
  const classes = useStyles();
  useSelector((state) => state.theme);
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const { appUser, isAuthorized, isMultiTenant } = useUser();

  return (
    <div
      className={classnames(classes.root, {
        [classes.open]: open,
        [classes.closed]: !open,
      })}
    >
      {isMultiTenant() && (
        <FormControl
          className={classnames({
            [classes.formControlOpen]: open,
            [classes.formControlClosed]: !open,
          })}
        >
          <Typography variant="body1">
            {truncateText(appUser?.reloadYard?.name, 21)}
          </Typography>
        </FormControl>
      )}

      <MenuItemLink
        to={DASHBOARD_PATH}
        primaryText="Find a Load"
        leftIcon={<SearchIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={DELIVERIES_PATH}
        primaryText="Deliveries"
        id="deliveries-menu-item"
        leftIcon={<InboundIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={PICKUPS_PATH}
        primaryText="Pickups"
        id="pickups-menu-item"
        leftIcon={<OutboundIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {isAuthorized(AclType.USERS) ? (
        <MenuItemLink
          to={`/carrierUsers`}
          primaryText="Users"
          id="users-menu-item"
          leftIcon={<UserIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      ) : (
        <MenuItemLink
          to={`/carrierUsers/${appUser?.id}`}
          primaryText="Profile"
          leftIcon={<ProfileIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {xsDown && (
        <MenuItemLink
          to="/logout"
          primaryText="Logout"
          leftIcon={<LogoutIcon />}
          sidebarIsOpen={open}
        />
      )}
    </div>
  );
};
